export const duration = 1.5;
export const primaryColor = "#0063dc"
export const primaryLightBackground = "#F9FCFF"
export const secondaryColor = "#c4b682"
export const darkGrey = "#606060"
export const lightGrey = "#F2F2F2"
export const superLightGrey = "#FBFBFB" // "#F9F9F9"
export const WINDOW_HEIGHT_WHEN_MINIMIZED = 50
